export default IconIceCream2 => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-ice-cream-2" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M17.657 11a6 6 0 1 0 -11.315 0" />
  <path d="M6.342 11l5.658 11l5.657 -11z" />
</svg>`;